<template>
  <page :basic="true">
    <span slot="header">{{ model.name }}</span>
    <template slot="breadcrumbs">
      <div class="d-flex">
        <b-link class="no-print" @click="goBack()"><i class="fa fa-arrow-left"/> Go back</b-link>
        <div class="flex-grow-1"></div>
        <div class="text-right no-print">
          <b-form-checkbox v-model="showAnswers" name="show-answers" switch>Show Answers</b-form-checkbox>
        </div>
      </div>
    </template>
    <div v-if="!isLoading">
      <div class="questions p-2">
        <div v-for="(question, idx) in questions" :key="question.id" class="question">

          <div class="d-flex p-2 question-content">
            <div class="question-label">
              {{ idx + 1 }}.
            </div>
            <question :question="question" :show-answer="showAnswers"></question>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import api from '@/api/knowledgechecks/knowledgecheck.js'
import page from '@/components/templates/page'
import question from './question'

export default {
  components:{
    page,
    question
  },
  data(){
    return{
      isLoading:true,
      model: {},
      questions: [],
      showAnswers: false
    }
  },
  computed:{
    ...mapState('tenants', {
      organization: 'current'
    }),
    knowledgeCheckId(){
      return this.$route.params.id
    },
    number(){
      return this.$route.params.number
    }
  },
  async mounted(){
    this.isLoading = true

    const params = {
      tenantId: this.organization.id,
      knowledgecheckId: this.knowledgeCheckId
    }

    const response = await api.show(params)
    this.model = response.data.data
    this.selectQuestions()
    this.isLoading = false
  },
  methods:{
    selectQuestions(){
      this.questions = this.model.questions.length <= this.number
        ? this.model.questions
        : this.getRandomQuestions()
    },
    getRandomQuestions(){
      let n = this.number
      const result = new Array(this.number)
      let len = this.model.questions.length
      const taken = new Array(len)

      while (n--) {
        const x = Math.floor(Math.random() * len)
        result[n] = this.model.questions[x in taken ? taken[x] : x]
        taken[x] = --len in taken ? taken[len] : len
      }
      return result
    },
    goBack(){
      this.$router.go(-1)
    }
  }

}
</script>

<style lang="scss" scoped>
.question-content{
  padding-left:1rem;
  page-break-inside:avoid;
  -webkit-column-break-inside: avoid;
  break-inside: avoid;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/print/index.vue